import { combineReducers } from "@reduxjs/toolkit";
import { auth } from "./auth";
import { notification } from "./notification";
import { invite } from "./invite";
import { entity } from "./entity";
import { module } from "./module";
import { feature } from "./feature";
import { application } from "./application";
import { workspace } from "./workspace";
import { readByUserIdReducer } from "./readByUserId";
import { attribute } from "./attribute";
import { menu } from "./menu.ts";
import { subscriptionPlan } from "./subscriptionPlan.ts";
import { roles } from "./role.ts";
import { authConfig } from "./authConfig.ts";
import { user } from "@/store/modules/user.ts";
import { deploy } from "@/store/modules/deploy.ts";
import { team } from "@/store/modules/team.ts";
import { base } from "@/store/modules/base.ts";
import { modal } from "@/store/modules/modal.ts";
import { generateCode } from "@/store/modules/generateCode.ts";
import { authApi } from "@/service/api/authApi";
import { deployApi } from "@/service/api/deployApi.ts";

export const rootReducer = combineReducers({
  [deployApi.reducerPath]: deployApi.reducer,
  auth: auth.reducer,
  authConfig: authConfig.reducer,
  base: base.reducer,
  deploy: deploy.reducer,
  entity: entity.reducer,
  notification: notification.reducer,
  invite: invite.reducer,
  module: module.reducer,
  modal: modal.reducer,
  menu: menu.reducer,
  team: team.reducer,
  generateCode: generateCode.reducer,
  // screen: screen.reducer,
  subscriptionPlan: subscriptionPlan.reducer,
  user: user.reducer,
  feature: feature.reducer,
  roles: roles.reducer,
  // screenDesign: screenDesign.reducer,
  application: application.reducer,
  attribute: attribute.reducer,
  workspace: workspace.reducer,
  readByUserId: readByUserIdReducer,
  [authApi.reducerPath]: authApi.reducer,
});
export type RootState = ReturnType<typeof rootReducer>;
